var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import Addon from "./Addon";
import { useIngredientsStock } from "../../../../Api/ingredientsApi";
import LookAtIngredients from "../../components/LookAtIngredients";
var Addons = function (_a) {
    var _b;
    var product = _a.product, incrementIngredient = _a.incrementIngredient, decrementIngredient = _a.decrementIngredient, storeId = _a.storeId, handleIngredientsClick = _a.handleIngredientsClick;
    var extras = useIngredientsStock(storeId).extras;
    var ingredients = extras !== null && extras !== void 0 ? extras : [];
    var addonIds = Array.isArray(product.details.addon_recommendations) &&
        product.details.addon_recommendations.length !== 0
        ? product.details.addon_recommendations
        : // @ts-ignore
            (_b = reactConfig === null || reactConfig === void 0 ? void 0 : reactConfig.addon_recommendations) !== null && _b !== void 0 ? _b : [];
    var filteredAddons = ingredients.filter(function (ingredient) {
        if (product.details.vegan_type === "vegan" &&
            !ingredient.tags.includes("vegan")) {
            return false;
        }
        return (!product.ingredients.find(function (prodIng) { return prodIng.product_id == ingredient.product_id; }) && addonIds.includes(ingredient.product_id.toString()));
    });
    var addons = addonIds
        .map(function (addonId) {
        return filteredAddons.find(function (addon) { return addon.product_id == addonId; });
    })
        .filter(function (n) { return n; }); // Filter out not found addons
    return (React.createElement("div", { className: "addons" },
        addons.slice(0, 3).map(function (ingredient) {
            return (React.createElement(Addon, { key: ingredient.product_id, ingredient: ingredient, incrementIngredient: function () {
                    return incrementIngredient(__assign(__assign({}, ingredient), { quantity: 1 }));
                }, decrementIngredient: function () {
                    return decrementIngredient(ingredient.product_id);
                } }));
        }),
        React.createElement(LookAtIngredients, { handleIngredientsClick: handleIngredientsClick })));
};
export default Addons;
